module.exports = __webpack_public_path__ + "media/Demo_Reel_02.421ec780.mp4";